import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core'
import {map, tap} from 'rxjs/operators'
import {ContactList, ContactsService} from '../../../api'
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {Observable, of} from "rxjs";

@Component({
    selector: 'ns-send-message-address-select',
    templateUrl: './send-message-address-select.component.html',
    styleUrls: ['./send-message-address-select.component.scss']
})
export class SendMessageAddressSelectComponent implements OnInit {
    @Input() group;
    public contacts$;
    fetchedContacts = [];

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private formBuilder: FormBuilder,
        private contactsService: ContactsService,
    ) {
        this.contacts$ = this.contactsService.contactListQuery()
          .pipe(
            map(res => res.data.map(contact => ({
                ...contact,
                name: `${contact.firstName} ${contact.lastName}`
            })))
          )
        this.contacts$.subscribe((res: ContactList[]) => {
            this.fetchedContacts = res;
        })
    }

    ngOnInit(): void {
    }

    afterViewInit(): void {
        this.changeDetectorRef.detectChanges()
    }

    handleFilterChange(query: string): void {
        this.contacts$ = this.contactsService.contactListQuery(null, null, query)
          .pipe(
            map(res => res.data.map(contact => ({
                ...contact,
                name: `${contact.firstName} ${contact.lastName}`
            })))
          )
    }

    public valueNormalizer = (text$: Observable<string>) =>
        text$.pipe(
            map((text: string) => {
                const matchingItem: any = this.fetchedContacts.find((item: any) => {
                   return item["email"].toLowerCase() === text.toLowerCase();
                 });
                 if (matchingItem) {
                     return matchingItem;
                 } else {
                     return {
                         name: text,
                         email: text
                     };
                 }
            })
        );
}
